import { render, staticRenderFns } from "./addAiNotebook.vue?vue&type=template&id=32bc3ffa&lang=pug"
import script from "./addAiNotebook.vue?vue&type=script&lang=js"
export * from "./addAiNotebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports